import { trackEvent } from './analytics';

const API_BASE_URL = '/api'; // Nginx経由でバックエンドにアクセス

export const analyze = async (payload) => {
    const mode = payload && payload.mode;
    const startedAt = Date.now();
    const elapsed = () => Math.round((Date.now() - startedAt) / 1000);

    trackEvent('analyze_start', { mode });

    let response;
    try {
        response = await fetch(`${API_BASE_URL}/analyze`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
    } catch (networkError) {
        // 通信そのものが失敗した場合(オフライン・タイムアウト等)
        trackEvent('analyze_error', { mode, reason: 'network', duration_sec: elapsed() });
        throw networkError;
    }

    if (!response.ok) {
        trackEvent('analyze_error', {
            mode,
            reason: 'http',
            status_code: response.status,
            duration_sec: elapsed(),
        });

        let errorData = {};
        try {
            errorData = await response.json();
        } catch (e) {
            console.error("API error response parse failed:", e);
            throw new Error(`API error (${response.status}): ${response.statusText}`);
        }

        // APIではdetailフィールドにエラー情報をセット
        const backendDetail = errorData.detail;
        let errorMessage = "An unexpected error occurred.";
        let backendErrors = [];

        if (backendDetail) {
            errorMessage = backendDetail.message || errorMessage;
            if (Array.isArray(backendDetail.errors)) {
                backendErrors = backendDetail.errors;
            }
        } else {
            errorMessage = errorData.message || errorMessage;
            if (Array.isArray(errorData.errors)) {
                backendErrors = errorData.errors;
            }
        }

        // カスタムエラーオブジェクトをスローして、詳細なエラー情報を渡す
        const customError = new Error(`API error (${response.status}): ${errorMessage}`);
        customError.backendMessage = errorMessage; // メインメッセージ
        customError.backendErrors = backendErrors; // 詳細なエラーリスト
        throw customError;
    }

    const result = await response.json();
    trackEvent('analyze_success', { mode, duration_sec: elapsed() });
    return result;
};
